import { useQuery } from '@tanstack/react-query';

import { titlesApi } from '../lib/api';

/**
 * Poll a title run until its generation finishes.
 *
 * `staleTime: 0` is required — the global default in App.tsx is 5 minutes,
 * which would serve a cached `pending` response and hang the spinner forever.
 *
 * Polls every 3s: a run is a single Claude call with a user watching, unlike
 * a blog job which takes minutes.
 */
export const useTitleRun = (runId: number | null) => {
  return useQuery({
    queryKey: ['title-run', runId],
    queryFn: () => titlesApi.getRun(runId as number),
    enabled: runId !== null,
    staleTime: 0,
    refetchInterval: (query) => {
      const status = query.state.data?.status ?? '';
      return status === 'completed' || status === 'failed' ? false : 3000;
    },
    retry: 1,
  });
};
